<script lang="ts">
  import { type Spacing } from "./types";
  export let minSpace: Spacing = "none";
  export let grow: boolean = true;
</script>
<div
  class="basis-stretch"
  class:grow
  class:min-h-2={minSpace === "s"}
  class:min-h-5={minSpace === "m"}
  class:min-h-10={minSpace === "l"}
  class:min-w-2={minSpace === "s"}
  class:min-w-5={minSpace === "m"}
  class:min-w-20={minSpace === "l"}
>
</div>
